export function filterInputKey(e, allowedInputs) {
  let isAllowed = allowedInputs
    .map(allowed => {
      if (e.key.match(allowed)) {
        return true;
      }
      return false;
    })
    .includes(true);

  if (!isAllowed) {
    e.preventDefault();
  }
}
